export default __webpack_public_path__ + "static/media/037-sprinkler.5f17b488.png";